// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"676":"aee3e414978845d2eeae","908":"4c210c1731771bdf015c"}[chunkId] + ".js";
};